import { render, staticRenderFns } from "./NumberWidget.vue?vue&type=template&id=584a3c54&scoped=true&"
import script from "./NumberWidget.vue?vue&type=script&lang=js&"
export * from "./NumberWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a3c54",
  null
  
)

export default component.exports